import dayjs from 'dayjs';
import { cx } from '@emotion/css';

import { useNavigator } from '../../routing/navigator';
import { PaymentOrder } from '../../shared/types/server-types';

import {
  historyListStyle,
  listItem,
  listItemContainerStyle,
  listItemTopContainerStyle,
  locationNameStyle,
} from './HistoryPage';

interface OrdersListProps {
  paymentOrders: PaymentOrder[];
}

export const OrdersList = (props: OrdersListProps): JSX.Element => {
  const { paymentOrders } = props;
  const navigator = useNavigator();

  const sorted = [...paymentOrders].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );

  return (
    <ul className={historyListStyle}>
      {sorted.map((order, index) => (
        <li key={index}>
          <button
            type="button"
            className={listItem}
            onClick={() => navigator.toPaymentOrderDetails(order.id)}
          >
            <div
              className={cx(listItemContainerStyle, listItemTopContainerStyle)}
            >
              <span>{dayjs(order.createdAt).format('DD.MM.YYYY.')}</span>
              <span>+ {parseFloat(order.amount).toFixed(2)} EUR</span>
            </div>
            <div className={listItemContainerStyle}>
              <span className={locationNameStyle}>
                {order.transactionType === 'PREAUTHORIZATION'
                  ? 'Card (reservation)'
                  : order.shopId === 'PREPAID'
                    ? 'Prepaid'
                    : 'Card'}
              </span>
            </div>
          </button>
        </li>
      ))}
    </ul>
  );
};
